import React from "react";
import Side from "./Side";
// import Cover from './Cover'
// import Simple from './Simple'
import View from "views";
import { useSelector } from "react-redux";
import { LAYOUT_TYPE_BLANK } from "constants/theme.constant";
import Simple from "./Simple";

const AuthLayout = (props) => {
  const layoutType = useSelector((state) => state.theme.layout.type);

  return (
    <div className="bg-[#004656] flex-1 flex flex-col bg-cover bg-no-repeat bg-center bg-fixed">
      {layoutType === LAYOUT_TYPE_BLANK ? (
        <Side>
          <View {...props} />
        </Side>
      ) : (
        <Side>
          <View {...props} />
        </Side>
      )}
    </div>
  );
};

export default AuthLayout;
